export const normalizeVariableName = (input: string): string =>
  input.toLowerCase().replace(/[^a-z0-9]+/g, "_");

export const toSnakeCase = (input: string): string =>
  normalizeVariableName(input).replace(/^_+|_+$/g, "");
